import { FieldValues } from "react-hook-form";

export const mapFormToRequestBody = async (props: FieldValues) => ({
  name: props.name,
  streetAddress: props.address,
  city: props.city,
  state: props.state,
  zipcode: props.zipcode,
  npi: props.npi,
  specialty: props.specialty,
  paymentContact: {
    contactName: props.contactName,
    contactPhone: props.contactPhone,
    contactEmail: props.contactEmail,
  },
  taxPayorIdNumber: props.taxId,
  stripeAccountNumber: props.stripeAccountNumber,
  emailToReceiveReports: props.emailToReceiveReports,
  emailToReceiveNotification: props.emailToReceiveNotification,
  classification: props.type,
  accountId: props.accountId,
  customPdfContent: props.customPdfEnabled
    ? {
        documentTitle: props.documentTitle,
        introductionText: props.introductionText,
        summaryLayout: props.summaryLayout,
        feeTableLayout: props.feeTableLayout,
        convenienceServiceFees:
          props.feeTableLayout === "chargeDescription"
            ? props.convenienceServiceFees
            : null,
        showDisclaimer: props.showDisclaimer,
        disclaimerType: props.showDisclaimer ? props.disclaimerType : null,
        showTermsAndConditions: props.showTermsAndConditions,
        termsAndConditionsText: props.showTermsAndConditions
          ? props.termsAndConditionsText
          : null,
      }
    : null,
});
